import React from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { ArrowLeft, Save, Printer } from 'lucide-react';
interface InboundGRNProps {
  onBack: () => void;
}
export function InboundGRN({
  onBack
}: InboundGRNProps) {
  return <div className="space-y-6" data-id="element-1066">
      <div className="flex items-center gap-4" data-id="element-1067">
        <Button variant="ghost" onClick={onBack} icon={<ArrowLeft size={20} data-id="element-1069" />} data-id="element-1068">
          Kembali
        </Button>
        <div data-id="element-1070">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1071">
            Penerimaan Barang (GRN)
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-1072">Input data penerimaan stok masuk</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1073">
        <div className="lg:col-span-2 space-y-6" data-id="element-1074">
          <Card title="Informasi Pengiriman" data-id="element-1075">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1076">
              <Input label="Nomor DO / Surat Jalan" placeholder="SJ-2025-XXX" data-id="element-1077" />
              <Input type="date" label="Tanggal Penerimaan" data-id="element-1078" />
              <Select label="Supplier / Asal" options={[{
              value: 's1',
              label: 'PT Pertani (Persero)'
            }, {
              value: 's2',
              label: 'Gapoktan Sumber Makmur'
            }, {
              value: 's3',
              label: 'Impor (Vietnam)'
            }]} data-id="element-1079" />
              <Input label="Nomor Polisi Kendaraan" placeholder="B 1234 XX" data-id="element-1080" />
            </div>
          </Card>

          <Card title="Hasil Penimbangan (Ton)" data-id="element-1081">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-1082">
              <Input label="Berat Bruto" placeholder="0.00" data-id="element-1083" />
              <Input label="Berat Tara" placeholder="0.00" data-id="element-1084" />
              <Input label="Berat Netto" placeholder="0.00" disabled className="bg-gray-50" data-id="element-1085" />
            </div>
          </Card>

          <Card title="Pemeriksaan Kualitas (QC)" data-id="element-1086">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4" data-id="element-1087">
              <Select label="Grade Hasil Lab" options={[{
              value: 'premium',
              label: 'Premium'
            }, {
              value: 'medium',
              label: 'Medium'
            }, {
              value: 'std',
              label: 'Standard'
            }, {
              value: 'reject',
              label: 'Reject / Tidak Layak'
            }]} data-id="element-1088" />
              <Input label="Kadar Air (%)" placeholder="14.0" data-id="element-1089" />
              <Input label="Butir Patah (%)" placeholder="5.0" data-id="element-1090" />
              <Input label="Benda Asing (%)" placeholder="0.0" data-id="element-1091" />
            </div>
            <Input label="Catatan QC" placeholder="Kondisi karung baik, tidak ada hama..." data-id="element-1092" />
          </Card>
        </div>

        <div className="space-y-6" data-id="element-1093">
          <Card title="Putaway Suggestion" data-id="element-1094">
            <div className="p-6 bg-gradient-to-br from-blue-50 to-blue-100 border-2 border-bulog-blue rounded-xl text-center" data-id="element-1095">
              <p className="text-sm font-medium text-bulog-blue mb-2" data-id="element-1096">
                Lokasi Disarankan:
              </p>
              <p className="text-4xl font-bold text-bulog-blue-dark mb-2" data-id="element-1097">
                A-04-02
              </p>
              <p className="text-xs text-blue-700" data-id="element-1098">Zona Beras Premium</p>
              <p className="text-xs text-blue-600 mt-1" data-id="element-1099">
                Kapasitas Tersedia: 50 Ton
              </p>
            </div>
            <div className="mt-4" data-id="element-1100">
              <Input label="Konfirmasi Lokasi (Scan Barcode)" placeholder="Scan Bin ID..." data-id="element-1101" />
            </div>
          </Card>

          <div className="flex flex-col gap-3" data-id="element-1102">
            <Button size="lg" icon={<Save size={18} data-id="element-1104" />} className="w-full" data-id="element-1103">
              Simpan & Finalisasi GRN
            </Button>
            <Button variant="outline" size="lg" icon={<Printer size={18} data-id="element-1106" />} className="w-full" data-id="element-1105">
              Cetak Berita Acara
            </Button>
          </div>
        </div>
      </div>
    </div>;
}